import { render, staticRenderFns } from "./HistoryListLink.vue?vue&type=template&id=9113939c&scoped=true&"
import script from "./HistoryListLink.vue?vue&type=script&lang=js&"
export * from "./HistoryListLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9113939c",
  null
  
)

export default component.exports